<div class="p-4">
  <div class="rounded-lg bg-white shadow">
    <div class="p-6">
      <app-client-datatable
        [data]="tableData"
        [config]="tableConfig"
        (dataChange)="onDataChange($event)"
        (sortChange)="onSortChange($event)"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        (searchChange)="onSearch($event)"
      ></app-client-datatable>
    </div>
  </div>
</div>
